import styled from 'styled-components';
import giftBackground from '../../../assets/images/giftBackground.svg';
import giftBackgroundMobile from '../../../assets/images/giftBackgroundMobile.svg';

export const BlockGiftCard = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.color.bgPopup};
  border-radius: 8px;

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    flex-direction: column;
  }
`;

export const Head = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 10px;
  align-items: center;
  width: 100%;
  padding: 14px 30px 31px;
  & > [type='submit'] {
    height: 36px;
    width: 288px;
    margin: 24px 0 0 0;
  }
`;

export const Row = styled.div`
  & ~ & {
    margin-top: ${({ theme }) => theme.indent.l};
  }
  width: 288px;
`;

export const GiftCardItem = styled.div.attrs({
  className: 'gift-card-item'
})`
  width: 100%;
  padding: 12px 15px;
  border-top: 1px solid #323232;

  .gift-card-item__content {
    padding: 14px 17px;
    display: grid;
    grid-template-columns: 25% 26% 49%;
    align-items: center;
    h3 {
      font-weight: 450;
      font-size: 18px;
      line-height: 26px;
      margin: 0 0 0 54px;
    }
    & > [type='submit'] {
      width: 288px;
      display: none;
    }
    &:hover {
      background: #2d2d2d;
      box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.104988);
      border-radius: 8px;
      & > [type='submit'] {
        display: block;
      }
    }
  }
`;

export const GiftCardBackGround = styled.div.attrs({
  className: 'gift-card-background'
})`
  position: relative;
  background-image: url(${giftBackground});
  background-repeat: no-repeat;
  height: 115px;
  width: 178px;

  .gift-card-background__barcode {
    position: absolute;
    height: 51px;
    width: 159px;
    bottom: 15px;
    left: 9px;
    border-radius: 8px;
    background: #ffffff;
    padding: 5px 8px 0;
    & > svg {
      height: 43px;
      width: 143px;
    }
  }
`;

export const NoGiftcards = styled.div.attrs({
  className: 'no-gift-cards'
})`
  height: 244px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & > .svg-gift-card-2 {
    width: 99px;
    height: 99px;
    fill: ${({ theme }) => theme.color.grey};
  }
  .no-gift-cards__label {
    font-weight: 390;
    font-size: 16px;
    line-height: 23px;
    color: ${({ theme }) => theme.color.grey};
    margin: 0;
  }
`;

export const List = styled.ul`
  max-width: 480px;
  text-align: left;
  margin: 0 20px;
  & > li {
    list-style: disc;
    display: list-item;
    margin-bottom: 8px;
  }
`;

export const ActiveGiftcards = styled.div.attrs({
  className: 'active-giftcards'
})`
  width: 100%;
  & > h3 {
    font-weight: 450;
    font-size: 16px;
    line-height: 24px;
    margin: 11px 0 12px 27px;
  }
`;

export const MobileHead = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 8px 14px 8px;
  border-top: 1px solid #323232;
  & > [type='submit'] {
    & > .svg-plus-circle {
      width: 24px;
      height: 24px;
      margin: 30px 0 0 32px;
    }
  }
`;

export const ActiveGiftCardItem = styled.div.attrs({
  className: 'active-giftcard-item'
})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 0 12px 0 8px;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-bottom: 21px;
  }
  .active-giftcard__item__barcode {
    display: flex;
    align-items: center;
    & > .svg-barcode {
      width: 30px;
      height: 24px;
    }
  }
  .active-giftcard__barcode__number {
    padding: 9px 23px 7px;
    border: 1px solid rgba(255, 255, 255, 0.403108);
    border-radius: 20px;
    margin-right: 9px;
    width: 183px;
    height: 40px;
    & > h3 {
      font-weight: 390;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const VerticalGiftcardContainer = styled.div.attrs({
  className: 'vertical-giftcard'
})`
  display: flex;
  justify-content: center;
  align-items: center;
  .vertical-giftcard__image {
    position: relative;
    background-image: url(${giftBackgroundMobile});
    background-repeat: no-repeat;
    height: 100%;
    height: 448px;
    width: 289px;
  }
  .vertical-giftcard__barcode {
    transform: rotate(270deg);
    position: absolute;
    height: 135px;
    width: 401px;
    bottom: 157px;
    left: -15px;
    border-radius: 8px;
    background: #ffffff;
    padding: 12px 20px;
    & > svg {
      height: 120px;
      width: 361px;
    }
  }
`;
